export const getCancellationRequestObjectId = (state) => state.cancellationRequestObject.getCancellationRequestId();
